import { DatePicker, Tabs } from "antd";
import { User, HeartPulse, ClipboardList, Syringe } from "lucide-react";
import { useTranslation } from "react-i18next";

import TabCustomerInfo from "./TabCustomerInfo";
import TabMedicalHistory from "./TabMedicalHistory";
import TabDoctorExam from "./TabDoctorExam";
import Layout from '../../../Layout'
import dayjs from "dayjs";

export default function ConsultationTabs() {
    const { t } = useTranslation();
    const items = [
        {
            key: "1",
            label: (
                <div className="flex items-center gap-2">
                    <User size={16} />
                    {t('skin_care.tab_info')}
                </div>
            ),
            children: <TabCustomerInfo />,
        },
        {
            key: "2",
            label: (
                <div className="flex items-center gap-2">
                    <HeartPulse size={16} />
                    {t('skin_care.tab_medical')}
                </div>
            ),
            children: <TabMedicalHistory />,
        },
        {
            key: "3",
            label: (
                <div className="flex items-center gap-2">
                    <ClipboardList size={16} />
                    {t('skin_care.tab_doctor')}
                </div>
            ),
            children: <TabDoctorExam />,
        },
    ];

    return (
        <Layout>
            <div className="flex justify-between mb-6">

                <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-emerald-600 text-white flex items-center justify-center rounded-lg">
                        <Syringe size={18} />
                    </div>

                    <div>
                        <h1 className="font-semibold text-lg text-000000e0">
                            {t('skin_care.page_title')}
                        </h1>
                        <p className="text-sm text-gray-500">
                            {t('skin_care.page_subtitle')}
                        </p>
                    </div>
                </div>

                <div className="flex items-center gap-2">
                    <DatePicker
                        defaultValue={dayjs()}
                        format="DD/MM/YYYY"
                        className="min-w-[160px]"
                    />
                </div>

            </div>
            <Tabs items={items} />
        </Layout>
    );
}